import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import usStates from 'utils/usStates'
import {
  getFieldProps,
  requiredLabel,
  useCreateProfileFieldStyles,
} from '../create-profile-form/field-styles'

export const Location = () => {
  const classes = useCreateProfileFieldStyles()
  const fieldProps = getFieldProps(classes)
  const { register, errors, control } = useFormContext()

  return (
    <Box className={classes.locationRow}>
      <TextField
        {...fieldProps}
        name="city"
        label={requiredLabel('City')}
        type="text"
        inputRef={register()}
        error={!!errors.city}
      />
      <Controller
        name="state"
        control={control}
        render={({ value, onChange }) => (
          <Autocomplete
            disableClearable
            value={value || ''}
            options={usStates}
            onChange={(e, nextValue) => onChange(nextValue)}
            className={classes.selectInput}
            renderInput={params => (
              <TextField
                {...params}
                {...fieldProps}
                label={requiredLabel('State')}
                error={!!errors.state}
              />
            )}
          />
        )}
      />
      <TextField
        {...fieldProps}
        name="zipCode"
        label={requiredLabel('Zip')}
        type="text"
        inputRef={register()}
        error={!!errors.zipCode}
      />
    </Box>
  )
}

export default Location
